var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_vm._v(" "+_vm._s(_vm.$t("page-errors.404"))+" "),_c('router-link',{attrs:{"to":"/"}},[_vm._v(" "+_vm._s(_vm.$t("page-errors.HomePage"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }